// src/PageTracker.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  initializeAnalytics,
  logPageView,
  initializeMetaPixel,
  logMetaPageView,
  // initializeTikTokPixel,
} from "./analytics";

const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    initializeAnalytics();
    initializeMetaPixel();
    // initializeTikTokPixel();
  }, []);

  useEffect(() => {
    const path = location.pathname.toLowerCase();

    // ✅ Track GA4 Page View
    logPageView(path);

    // ✅ Track Meta Pixel Page View
    logMetaPageView(path);
  }, [location.pathname]);

  return null;
};

export default PageTracker;
